import { bootstrapApplication } from "@angular/platform-browser";
import dayjs from "dayjs";
import customParseFormat from "dayjs/plugin/customParseFormat";
import { AppComponent } from "./app/app.component";
import { appConfig } from "./app/app.config";
import { environment } from "./environments/environment";
import type { MockMode } from "./mocks/browser";
dayjs.extend(customParseFormat);

async function bootstrap() {
  if (environment.mockEnabled) {
    const { startMockWorker } = await import("./mocks/browser");
    await startMockWorker(environment.mockMode as MockMode);
  }

  await bootstrapApplication(AppComponent, appConfig);
}

bootstrap().catch((err) => console.error(err));
